// page src/pages/subscription/components/SubscriptionPlans.tsx
import {
    useEffect,
    useState,
} from "react";

import {
    subscriptionService,
} from '../../../services/subscriptionService'

import type {
    SubscriptionPlan,
} from "../../../types/payment";

import PlanCard from "./PlanCard";
import { useNavigate } from "react-router-dom";

interface Props {
    hideFreePlans?: boolean;
    activeSubscription?: any;
}

export default function SubscriptionPage({ hideFreePlans = false, activeSubscription: activeSubscriptionProp }: Props = {}) {

    const [plans, setPlans] = useState<SubscriptionPlan[]>([]);
    const [loading, setLoading] = useState(true);
    const [activeSubscription, setActiveSubscription] = useState<any>(activeSubscriptionProp ?? null);
    const navigate = useNavigate();
    const userId = localStorage.getItem("user_id") || "";

    const openPlanModal = (plan: SubscriptionPlan) => {
        navigate("/subscription/checkout", { state: { plan } });
    };

    useEffect(() => {
        loadPlans();
    }, []);

    const loadPlans = async () => {
        try {
            // Only fetch subscription if not already provided by parent
            const [plansData, subscriptionData] = await Promise.all([
                subscriptionService.getPlans(),
                activeSubscriptionProp === undefined && userId
                    ? subscriptionService.getMySubscription(userId).catch(() => null)
                    : Promise.resolve(null)
            ]);

            setPlans(plansData);
            if (subscriptionData) setActiveSubscription(subscriptionData);

        } catch (error) {
            console.error("Failed to load plans:", error);
        } finally {
            setLoading(false);
        }
    };



    return (

        <div className="min-h-screen bg-brand-bg">

            <div className="max-w-7xl mx-auto px-6 py-16">

                {/* Header */}
                <div className="text-center mb-12">
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#00ADC4]/10 text-[#00ADC4] text-xs font-sans font-bold uppercase tracking-widest mb-6">
                        <i className="ri-vip-crown-2-line"></i>
                        Subscription Plans
                    </div>

                    <h2 className="text-4xl font-heading font-black text-[#222222] mb-4 tracking-tight">
                        Choose Your Perfect Plan
                    </h2>

                    <p className="text-base font-sans font-light text-[#222222]/70 max-w-2xl mx-auto">
                        Unlock advanced marketing intelligence,
                        AI-powered insights, analytics,
                        automation, and premium support.
                    </p>
                </div>

                {/* Loading State */}
                {loading && (
                    <div className="flex justify-center py-20">
                        <div className="flex items-center gap-3 text-[#0859B8]">
                            <div className="animate-spin rounded-full h-6 w-6 border-2 border-[#0859B8] border-t-transparent"></div>
                            <span className="font-heading font-bold text-[#222222]">
                                Loading subscription plans...
                            </span>
                        </div>
                    </div>
                )}

                {/* Empty State */}
                {!loading &&
                    plans.length === 0 && (
                        <div className="bg-[#FDFFFC] rounded-[20px] border-2 border-gray-200 p-12 text-center">
                            <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gray-50 border border-gray-200 flex items-center justify-center">
                                <i className="ri-inbox-line text-4xl text-gray-400"></i>
                            </div>
                            <h3 className="text-xl font-heading font-black text-[#222222] mb-2">
                                No Plans Available
                            </h3>
                            <p className="font-sans font-light text-[#222222]/70">
                                Subscription plans are currently unavailable.
                            </p>
                        </div>
                    )}

                {/* Plans Grid */}
                {!loading &&
                    plans.length > 0 && (

                        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-8">

                            {plans.filter(plan => !(hideFreePlans && Number(plan.price) === 0)).map((plan) => (

                                <PlanCard
  key={plan.id}
  plan={plan}
  userId={userId}
  activeSubscription={activeSubscription}
  onSelectPlan={openPlanModal}
/>

                            ))}

                        </div>

                    )}
                    

            </div>

        </div>

    );
    
}